import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetAbstractListApi } from '@/api/conference';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { ABSTRACT_CONFERENCE_NAME } from '@/constants/menu';

import * as S from './style';

const AbstractConfirm = () => {
	const navigate = useNavigate();

	const [page, setPage] = useState(1);

	const { data: abstractListData } = useGetAbstractListApi({
		conference_name: ABSTRACT_CONFERENCE_NAME,
		page: page,
		row: 10,
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	return (
		<S.Container noData={abstractListData?.abstract?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>이전 화면으로</span>
			</S.BackButton>
			{abstractListData?.abstract?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={abstractListData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{abstractListData?.abstract?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="date">{item.abstract_enrollment_date}</p>
									<div className="abstract-info">
										<div>
											<span>{item.abstract_presentation}</span>
											{item.abstract_presentation === '구두 발표' && (
												<S.Badge status={item.abstract_approve === 'approve' ? 'approve' : 'reject'}>
													{item.abstract_approve === 'approve' ? '선정' : '미선정'}
												</S.Badge>
											)}
										</div>
										<p>{item.abstract_division}</p>
									</div>
									<p>{item.abstract_conference_name}</p>
								</S.TableContent>
								<S.Button href={item.file_path} target="_blank" rel="noopener noreferrer">
									초록 확인
								</S.Button>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>등록 내역이 없습니다.</S.NoData>
			)}
		</S.Container>
	);
};
export default AbstractConfirm;
